function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import Heading from './Heading';
export const PageSubtitle = _ref => {
  let {
    as = 'h2',
    fontSize = ['mobileSubtitle', 'subtitle'],
    mb = 3,
    textAlign = ['center', 'left'],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: as,
    fontSize: fontSize,
    mb: mb,
    textAlign: textAlign
  }, props));
};
PageSubtitle.propTypes = {
  ...Heading.propTypes,
  children: PropTypes.string.isRequired
};
PageSubtitle.displayName = 'PageSubtitle';
export default PageSubtitle;